<!-- 客户及分销头部 -->
<template>
    <div class='clientTop'>
        <div class="clientTopLeft">
            <div class="clientTopLeftT">
                <p class="p1">点击下方新建客户互动营销</p>
                <p class="p2">查看全部客户营销活动</p>
            </div>
            <div class="clientTopLeftB">
                <div class="left">
                    <i style="font-size: 0.36rem;cursor: pointer" class="el-icon-arrow-left"></i>
                </div>
                <div class="center" v-for="(item, index) in 2" :key="index">
                    <div class="card" @click="$emit('ActivityDetail')">
                        <div class="cardL">
                            <div class="cardTitle">
                            </div>
                            <div class="cardText">
                                礼<span>包</span>
                            </div>
                        </div>
                        <div class="cardR">
                            <p class="p1">旅游基金限时领</p>
                            <p class="p2">优惠券礼包</p>
                            <p class="p3">用户一次获得多张优惠券</p>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <i style="font-size: 0.36rem;cursor: pointer;" class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>
        <div style="padding: 0.2rem 0;">
            <div class="line"></div>
        </div>
        <div class="clientTopRight">
            <div @click="shareCustomer" class="clientTopRightT">
                快快分享给你的客户
            </div>
            <div class="clientTopRightB">
                <div class="clientTopRightBL">
                    <i style="font-size: 0.2rem;cursor: pointer;" class="el-icon-caret-top"></i>
                    <div class="clientTopRightBLLineBox">
                        活动时间：2021.09.30-12.03 同业专享
                    </div>
                    <i style="font-size: 0.2rem;cursor: pointer;" class="el-icon-caret-bottom"></i>
                </div>
                <div class="clientTopRightBR">
                    <div class="imgBox" style="margin-right: 0.22rem;">
<!--                        <img style="width: 1.2rem;height: 1.2rem;" :src="require('@/assets/png/wxEr.png')" alt="">-->
                        <qr :size="100" :text="text"></qr>
                        <p>1 微信扫描二维码</p>
                    </div>
<!--                    <div class="imgBox">-->
<!--                        <img style="width: 0.8rem;height: 1.2rem;" :src="require('@/assets/png/fenx1.png')" alt="">-->
<!--                        <p>2 点击...分享页面</p>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Qr from "@/components/Qr.vue";
export default {
    components: {
        Qr
    },
    data() {
        return {
            //二维码分享地址
            text:'',
        }
    },
    computed: {},
    watch: {},
    methods: {
        //分享客户
        shareCustomer() {
            let platUserId = this.$store.state.userInfor.userId
            this.text = process.env["VUE_APP_CUSTOMER_H5_SERVE"] + `?platUserId=${platUserId}`
            console.log(this.text,'sllsdlsldls')
        }
    },
    created() {

    },
    mounted() {
        this.shareCustomer()
    },
}
</script>
<style lang='scss' scoped>
.clientTop {
    height: 2.4rem;
    color: rgba(16, 16, 16, 1);
    background-color: #fff;
    display: flex;

    .clientTopLeft {
        flex: 1;
        padding: 0.3rem 0.35rem;

        .clientTopLeftT {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.2rem;
            padding: 0 0.6rem;

            .p1 {
                color: rgba(57, 72, 87, 1);
                font-size: 0.18rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
            }

            .p2 {
                color: rgba(57, 72, 87, 1);
                font-size: 0.14rem;
                font-family: SourceHanSansSC-bold;
                font-weight: bold;
            }
        }

        .clientTopLeftB {
            display: flex;
            align-items: center;

            .left {}

            .center {
                flex: 1;
                margin: 0 0.2rem;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .card {
                    width: 3rem;
                    height: 1.3rem;
                    background-color: #E76860;
                    border-radius: 0.1rem;
                    display: flex;
                    overflow: hidden;
                    cursor: pointer;

                    .cardL {
                        width: 30%;
                        position: relative;

                        .cardTitle {
                            position: absolute;
                            left: -50%;
                            top: 0.1rem;
                            background-color: #474C5A;
                            width: 1.1rem;
                            height: 1.1rem;
                            border-radius: 0.1rem 0 0.1rem 0;
                            transform: rotate(45deg);

                            .cardTitle {
                                text-align: center;
                                line-height: 1.1rem;
                            }
                        }

                        .cardText {
                            position: absolute;
                            top: 50%;
                            left: 0.2rem;
                            transform: translateY(-50%);
                            font-size: 0.25rem;
                            font-weight: bold;
                            color: #fff;

                            span {
                                font-size: 0.16rem;
                            }
                        }
                    }

                    .cardR {
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        justify-content: center;
                        .p1 {
                            color: rgba(16, 16, 16, 1);
                            font-size: 0.14rem;
                            font-family: SourceHanSansSC-regular;
                        }
                        .p2 {
                            color: #fff;
                            font-size: 0.18rem;
                        }
                        .p3 {
                            color: #DEBEC6;
                            font-size: 0.14rem;
                        }
                    }
                }
            }

            .right {}
        }



    }

    .line {
        margin: 0 0.2rem;
        width: 1rpx;
        height: 100%;
        border-right: 1px solid #E8EBEF;
    }

    .clientTopRight {
        flex: 1;
        padding: 0.2rem 0.35rem;

        .clientTopRightT {
            height: 0.4rem;
            line-height: 0.4rem;
            background-color: rgba(139, 70, 70, 1);
            text-align: center;
            color: rgba(248, 248, 248, 1);
            font-size: 0.14rem;
            font-family: SourceHanSansSC-light;
            margin-bottom: 0.18rem;
        }

        .clientTopRightB {
            display: flex;

            .clientTopRightBL {
                padding: 0.1rem 0;
                flex: 1;
                height: 1.5rem;
                border-radius: 2px 2px 2px 2px;
                background-color: rgba(250, 250, 250, 1);
                margin-right: 0.37rem;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                .clientTopRightBLLineBox {
                    height: 0.32rem;
                    line-height: 0.32rem;
                    width: 100%;
                    color: #6b7785;
                    background-color: rgba(10, 151, 186, 0.06);
                    text-align: center;
                    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.07);
                    cursor: pointer;
                }
            }

            .clientTopRightBR {
                display: flex;

                .imgBox {
                    display: flex;
                    flex-direction: column;

                    img {
                        margin-bottom: 0.12rem;
                    }

                    p {
                        left: 1483px;
                        color: rgba(57, 72, 87, 1);
                        font-size: 0.12rem;
                        font-family: SourceHanSansSC-regular;
                    }
                }
            }
        }
    }
}</style>